/** @param {Record<string, unknown>|undefined} billing */
export function billingPdfRows(billing) {
    return [
        { label: 'Full name', value: billing?.name },
        { label: 'Company', value: billing?.company },
        { label: 'VAT no.', value: billing?.vat },
        { label: 'Street', value: billing?.street },
        { label: 'Town / city', value: billing?.city },
        { label: 'Post code', value: billing?.postCode },
        { label: 'Phone', value: billing?.phone },
        { label: 'Email', value: billing?.email },
    ];
}

/** @param {Record<string, unknown>|undefined} delivery */
export function deliveryPdfRows(delivery) {
    return [
        { label: 'Full name', value: delivery?.name },
        { label: 'Company', value: delivery?.company },
        { label: 'VAT no.', value: delivery?.vat },
        { label: 'Street', value: delivery?.street },
        { label: 'Town / city', value: delivery?.city },
        { label: 'Post code', value: delivery?.postCode },
        { label: 'Phone', value: delivery?.phone },
        { label: 'Email', value: delivery?.email },
    ];
}
